import { Component } from '@angular/core';

@Component({
  templateUrl: './onboarding.page.html',
})
/**
 * Onboarding page after account migration
 */
export class OnboardingPage {}
